import { Accordion } from '@iwoca/orion';
import { Text } from '@iwoca/orion-ui';
import { FormattedMessage } from 'react-intl';

export const CreditCardFAQs = () => (
    <div className="my-xl">
        <Text className="mb-l text-l font-bold">
            <FormattedMessage
                id="_.credit_card.faq.title"
                defaultMessage="FAQs"
            />
        </Text>
        <Accordion
            title={
                <FormattedMessage
                    defaultMessage="How do I close my account?"
                    id="_.credit_card.faq.how_do_i_close"
                />
            }
            small
        >
            <Text>
                <FormattedMessage
                    id="_.credit_card.faq.account_closure"
                    defaultMessage="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                />
            </Text>
        </Accordion>
    </div>
);
